import { simpleFetch } from './customFetch';

export const getTaxRate = (plan, shippingCountry, zipCode) => (
  simpleFetch(
    '/api/v1/get-tax-rate',
    {
      method: 'POST',
      credential: 'omit',
      body: JSON.stringify({
        plan,
        ship_country: shippingCountry,
        zip_code: zipCode,
      }),
    },
    process.env.REACT_APP_TAX_API,
  )
);
